import { render } from "./AdminBreakdownCard.vue?vue&type=template&id=b1ecb686"
import script from "./AdminBreakdownCard.vue?vue&type=script&lang=js"
export * from "./AdminBreakdownCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__